import './App.css';
import Sidebar from './components/Sidebar';
import Content from './components/Content';
import {BrowserRouter,Routes,Route } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';

import List from './components/List';

function App() {

  const userName="aditya";
  const userAge=30;

  return (
   <>
   
   <div className='container main'>
   
    <div className='row'>
       <BrowserRouter>
       <Sidebar/>
        <Routes>
          <Route path="/" element={<Content/>} />
          <Route path='/login' element={<Login name={userName} age={userAge} />} />
          <Route path='register' element={<Register/>} />

          <Route path='/list' element={<List/>} />
        </Routes>
      </BrowserRouter>
   

     </div>

   </div>
   
   </>
  );
}

export default App;
